import React from 'react';
import Options from '../dashboard/partials/options';
import fakeAuth from '../../../fakeAuth';
import Card from './partials/card';
import Gear from '../../partials/gear';
import { Link } from 'react-router';

class Affiliates extends React.Component {
    state = {
        microTransac: false,
        sponsors: null
    }
    componentWillMount() {
        const { sponsors, sponsorsActions } = this.props;
        if (!sponsors) this.setState({ microTransac: true }, () => {
            sponsorsActions && sponsorsActions.fetch();
        });
        else this.setState({ sponsors });
    }
    componentWillReceiveProps = nextProps => {
        const { sponsors } = nextProps;
        this.setState({ sponsors, microTransac: false });
    }
    logout = () => {
        fakeAuth.signout(() => {
            this.props.router.push('/admin');
        });
    }
    render() {
        const { microTransac, sponsors = [] } = this.state;
        return (
            <section className="d-flex flex-column h-100">
                <div className="d-flex flex-row p-4">
                    <Link to="/admin/dashboard" className="align-self-center idented d-flex flex-row white font-16">
                        <i className="fas fa-arrow-left margin-right align-self-center" />
                        <span className="anton align-self-center">BACK</span>
                    </Link>
                    {microTransac && <Gear className="ml-auto" />}
                    <h1 className="anton ml-auto align-self-center no-margin no-padding text-right white padding-right">SPONSORS</h1>
                </div>
                <div className="h-100" style={{ position: 'relative' }}>
                    <section id="left" style={{ position: "absolute", top: 0, bottom: 0, left: 0, width: 200 }} className="">
                        <Options current={5} onLogout={this.logout} />
                    </section>
                    <section id="left" style={{ position: "absolute", overflowY: 'auto', top: 0, bottom: 0, left: 200, right: 0 }} className="clearfix">
                        <Link to="/admin/sponsors/add" style={{ float: 'left' }}>
                            <figure className="card p-4 margin-right d-flex flex-column justify-content-center pointer hover-red bg-info" style={{ width: 250, height: 250 }}>
                                <i className="fa fa-plus font-50 align-self-center white" />
                                <span className="align-self-center margin-top-half font-14 white">Add Sponsor</span>
                            </figure>
                        </Link>
                        {sponsors && sponsors.map((sponsor, index) => <Card sponsor={sponsor} key={index} index={index} />)}
                    </section>
                </div>
            </section>
        )
    }
}

export default Affiliates;



// WEBPACK FOOTER //
// ./src/components/private/sponsors/index.js